// extracted by mini-css-extract-plugin
export default {"wrapper":"TopUp_wrapper__jxPWm","icon-container":"TopUp_icon-container__S+Mhr","icon":"TopUp_icon__DulmM","card":"TopUp_card__mjcKf"};